// extracted by mini-css-extract-plugin
module.exports = {"orDivider":"OrDivider_orDivider__FQC7m"};